import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { Button } from '@components/ui/button';
import { PublishScheduleConfirmationNotificationSummary } from '../publish/confirmation/notificationSummary';
import { useRescheduler } from '@contexts/rescheduler';
import { initialState } from '@contexts/rescheduler/constants';
import { formatDate } from 'date-fns';

export const ScheduleConfirmationDialog = () => {
  const { t } = useTranslation('app');

  const { showSummary, scheduleSummary, relatedSchedules, setState } = useRescheduler();

  if (relatedSchedules.length) return;
  if (!showSummary) return;
  if (!scheduleSummary?.date) return;

  const { date, crewsWithPhoneIds, fieldUserAsCrewIds, uniqueForemenIds, crewsWithoutPhoneIds } =
    scheduleSummary;
  const handleClose = () => setState(initialState);

  const totalCount = Array.from(
    new Set([
      ...(crewsWithPhoneIds || []),
      ...(fieldUserAsCrewIds || []),
      ...(uniqueForemenIds || []),
    ]),
  ).length;

  return (
    <AlertDialog open={showSummary} onOpenChange={handleClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('publisher.date.confirmationTitle', {
              date: formatDate(new Date(date), 'MMM do'),
              count: totalCount || 0,
            })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('publisher.confirmationDescription.first')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <PublishScheduleConfirmationNotificationSummary
          crewsWithPhoneIds={crewsWithPhoneIds || []}
          crewsWithoutPhoneIds={crewsWithoutPhoneIds || []}
          fieldUserAsCrewIds={fieldUserAsCrewIds || []}
          uniqueForemenIds={uniqueForemenIds || []}
          title={t('publisher.notification.confirmationTitle')}
        />
        <AlertDialogFooter>
          <Button onClick={handleClose} variant="secondary" disabled={false}>
            {t('actions.close')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
